import * as React from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Button from '../components/Button';
import Typography from '../components/Typography';
import ContactPopup from '../components/Contactpopup';

const item = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  px: 5,
};

const number = {
  fontSize: 24,
  fontFamily: 'default',
  color: 'secondary.main',
  fontWeight: 'medium',
  marginBottom: '15px'
};

const image = {
  height: 55,
  my: 4,
};

function ProductHowItWorks() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleMailTo = () => {
    window.location.href = 'mailto:solutions@mktech.cloud';
  };

  return (
    <Box
      id='mastery'
      component="section"
      sx={{ display: 'flex', bgcolor: 'primary.light', overflow: 'hidden' }}
    >
      <Container
        sx={{
          mt: 10,
          mb: 15,
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box
          component="img"
          alt="curvy lines"
          sx={{
            pointerEvents: 'none',
            position: 'absolute',
            top: -180,
            opacity: 0.7,
          }}
        />
        <Typography variant="h4" marked="center" component="h2" sx={{ mb: 14, textAlign: 'center' }}>
        Your Path to Cloud Mastery, <br/><i>Simplified</i>
        </Typography>
        <div>
          <Grid container spacing={5}>
            <Grid item xs={12} md={4}>
              <Box sx={item}>
                <Box sx={number}>1.</Box>
                <Typography variant="h5" align="center">
                <b>Discover & Strategize:</b><br/>Begin with a comprehensive assessment where we identify your cloud ambitions and the technical landscape. Our experts craft a tailored strategy that aligns with your business goals, ensuring a seamless transition to the cloud.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box sx={item}>
                <Box sx={number}>2.</Box>
                <Typography variant="h5" align="center">
                <b>Customized Solutions Deployment:</b><br/>Leveraging our deep expertise in AWS and cloud technologies, we design and deploy solutions that are as unique as your business. From secure cloud migrations to efficient cloud-native applications, we turn your cloud vision into reality.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box sx={item}>
                <Box sx={number}>3.</Box>
                <Typography variant="h5" align="center">
                <b>Ongoing Optimization & Support:</b><br/>The journey doesn't end with deployment. We continuously monitor, manage, and optimize your cloud environment to ensure peak performance. With MK Technologies, you gain a partner dedicated to your long-term success in the digital realm.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </div>
        <Button
          color="secondary"
          size="large"
          variant="contained"
          onClick={handleMailTo}
          sx={{ mt: 8, borderRadius:1 }}
        >
          Get started
        </Button>
        <ContactPopup open={open} handleClose={handleClose} />
      </Container>
    </Box>
  );
}

export default ProductHowItWorks;
